import { isFeatureEnabled } from 'owa-feature-flags';

const supportedOfficeRailApps = ['Yammer', 'Bookings'];

export default function isSupportedOfficeRailApp(appName: string) {
    return isFeatureEnabled('tri-officeRailHost') && supportedOfficeRailApps.includes(appName);
}
